import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const Congrats = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/appointment-requests');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-end h-screen gap-20 [@media(min-width:1800px)]:gap-40 bg-white p-20">
      <div className="w-[6.375rem] h-[5.75969rem]">
        <img src="/images/logo.svg" alt="Loop Logo" className="w-full h-full" />
      </div>
      <div className="space-y-1">
        <h2 className="font-serif text-[#5B73F1] text-center text-[2.875rem] font-bold leading-[3.9375rem]">
          Congratulations!
        </h2>
        <p className="text-[#FF85BC] text-center text-[2rem] font-normal leading-[2.4375rem]">
          Your Profile is ready!
        </p>
      </div>
      <div className="flex flex-col items-center justify-center gap-[1.69rem]">
        <span className="inline-flex items-center justify-center bg-[#FF85BC] size-14 rounded-full text-[#5B73F1] text-[1.3125rem] font-bold leading-normal">
          {countdown}
        </span>
        <p className="text-center text-[#21272A] text-xl font-normal leading-normal">
          You'll be directed to Setup your Account.
        </p>
      </div>
    </div>
  )
}
